import { QRCodeSVG } from "qrcode.react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

interface Props {
  qrToken?: string;
  open: boolean;
  onClose: () => void;
}

export default function MemberQrCard({ qrToken, open, onClose }: Props) {

  const qrValue = `https://www.gyminify.com/qr/member/${qrToken}`;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      {qrToken ? (
        <>
          <DialogTitle textAlign="center">
            Your QR Code
          </DialogTitle>
          <DialogContent>
            <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          p={2}
        >

          <QRCodeSVG
            value={qrValue}
          />

          <Typography variant="body2" mt={2} color="text.secondary">
            Show this QR at reception
          </Typography>
        </Box>
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", pb: 2 }}>

        <Button variant="contained" onClick={onClose}>
          Close
        </Button>
      </DialogActions>
      </>
      ) : (
        <>
          <DialogTitle textAlign="center">
            No QR Code Available
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" mt={2} color="text.secondary">
              Please contact support to generate a QR code.
            </Typography>
          </DialogContent>
        </>
      )}
    </Dialog>
  );
}